var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 8 10.5",
    style: {
      enableBackground: "new 0 0 8 10.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#DDDBDA;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(127.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1_00000086659847562220480430000014880466017727200651_",
    className: "st0",
    d: "M-126.7-6.3h7.5c0.2,0,0.4,0.3,0.2,0.4 l-3.6,4.2c-0.1,0.2-0.4,0.2-0.5,0l-3.7-4.2C-127.1-6-127-6.3-126.7-6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-2",
    className: "st0",
    d: "M-126.7-7.3h7.5c0.2,0,0.4-0.3,0.2-0.4l-3.6-4.2c-0.1-0.2-0.4-0.2-0.5,0l-3.7,4.2 C-127.1-7.5-127-7.3-126.7-7.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.23542141ebf938a16233f952f593c208.svg";
export { ForwardRef as ReactComponent };